import React from 'react'

export default function WebsitePortfolio() {
  return (
    <div>
      <div className="home-container">
        <div
          className="allHeaderBg"
        >
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1
                className="head text-center text-white animate__animated animate__zoomIn allHeaderP"
              >
                Website Portfolio
              </h1>
            </div>
          </div>
        </div>
      </div>
      <section
        className="clients-portfolio-section mt-4"
        style={{ backgroundColor: "#f1f3fe" }}
      >
        <div className="container mt-4">
          <div className="section-title mb-1 text-center">
            <h2> Web Development Projects </h2>
            <h3>
              Our Portfolio Of <span>Web Development Projects</span>{" "}
            </h3>
            <p className="mt-0">
              Explore our diverse portfolio of web development projects that showcase our expertise in creating dynamic, user-friendly, and visually appealing websites. From e-commerce platforms to corporate websites, our work reflects our commitment to delivering high-quality digital solutions tailored to meet our clients' unique needs.
            </p>
          </div>
          <div className="container">
            

            <div className="row mt-1">
              
            </div>
            <div className="row mt-0">
              <div className="col-md-3 mb-3  ">
                <a
                  href="https://firstclicksolutions.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\first-click-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="first-click-portfolio-technicmentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >FIRST CLICK SOLUTIONS</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a
                  href="https://farooq-graphics.vercel.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\farooqgraphic-portfolio.png"
                    className="img-fluid portfolio-images"
                    alt="farooqgraphic-portfolio"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >FAROOQ GRAPHICS</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a
                  href="https://legalexglobal.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\legalexglobal-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt=""
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >LEGALEX GLOBAL</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a href="https://getwell.pk/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\getwell-website-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt=""
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >GET WELL</h2>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-3 mb-3  ">
                <a
                  href="https://almahdia.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\almahdia-clothing-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="almahdia-clothing-technicmentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >AL MAHDIA</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a
                  href="https://bashirahmedsons.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\bashir-ahmed-sons-website.webp"
                    className="img-fluid portfolio-images"
                    alt="bashir-ahmed-sons-website"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >BASHIR AHMED SONS</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a
                  href="https://capobiz.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\capobiz-website-technic-mentors.png"
                    className="img-fluid portfolio-images"
                    alt="capobiz-website-technic-mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >CAPOBIZ</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a
                  href="https://sheikhlawcompany.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\sheikh-law-website-portfolio.webp"
                    className="img-fluid portfolio-images"
                    alt="sheikh-law-website-portfolio"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >SHEIKH LAW COMPANY</h2>
                </div>
              </div>

            </div>

            <div className="row mt-4">
              <div className="col-md-3 mb-3  ">
                <a
                  href="https://mentorsacademia.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\mentors-academia.webp"
                    className="img-fluid portfolio-images"
                    alt=" mentors-academia by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >MENTORS ACADEMIA</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3 ">
                <a
                  href="https://nsfittings.pk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\ns-fitting-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt="ns-fitting-technic-mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >NS FITTINGS
                  </h2>
                </div>
              </div>

              <div className="col-md-3 mb-3  ">
                <a
                  href="https://peerjanjua.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\peer-janjua-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt="peer-janjua-technic-mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >PEER JANJUA</h2>
                </div>
              </div>

              <div className="col-md-3 mb-3  ">
                <a
                  href="https://bcdserve.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\bcd-serve-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt=""
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >BCD SERVICES</h2>
                </div>
              </div>

            </div>

            <div className="row mt-4">

              
              <div className="col-md-3 mb-3 ">
                <a href="https://mlglobaltesting.com/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\ml-global-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt="ML global website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Ml Global Testing</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a href="https://abdullahkneaders.com/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\abdullah-traders-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt="Abdullah Kneaders website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Abdullah Kneaders</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a
                  href="https://pees.pk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\pees-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="PEES website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >PHOTONICS ENGINEERING</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3  ">
                <a href="https://k2land.pk/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\k2-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="k2 LAND website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >k2 LAND</h2>
                </div>
              </div>
            </div>

            <div className="row mt-4">

              <div className="col-md-3 mb-3 ">
                <a href="https://home-painting-frontend.vercel.app/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\home-painting.png"
                    className="img-fluid portfolio-images"
                    alt="Home Painting website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >HOME PAINTING</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a href="https://review.imlpk.com/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\intermarket-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="INTER MARKET website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >INTER MARKET</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a
                  href="https://capobrain.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\capobrain-school-management.png"
                    className="img-fluid portfolio-images"
                    alt=" Capobrain-school management website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >CAPOBRAIN</h2>
                </div>
              </div>
               <div className="col-md-3 mb-3 ">
                <a
                  href="https://brilliantbosshr.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\brilliant-boss-hr.png"
                    className="img-fluid portfolio-images"
                    alt="Brilliant Boss HR Consultancy website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >BRILLIANT BOSS HR </h2>
                </div>
              </div>
              
            </div>

             <div className="row mt-4">

              <div className="col-md-3 mb-3 ">
                <a href="https://dental-lab-frontend.vercel.app/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\dental-labs.png"
                    className="img-fluid portfolio-images"
                    alt="Dental Labs website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Dental Labs</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a href="https://fa-one-foods.vercel.app/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\fa-one-food-web-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="FA ONE FOODS website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >FA ONE FOODS</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a
                  href="https://galaxify-frontend.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\galaxify-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="Galaxify website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Galaxify</h2>
                </div>
              </div>
               <div className="col-md-3 mb-3 ">
                <a
                  href="https://immiconsult-frontend.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\immi-consultant-portfolio.png"
                    className="img-fluid portfolio-images"
                    alt="Immi consultant website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Immi consultant</h2>
                </div>
              </div>
              
            </div>


  <div className="row mt-4">

              <div className="col-md-3 mb-3 ">
                <a href="https://job-portal-frontend-eosin-ten.vercel.app/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\job-portal-website.png"
                    className="img-fluid portfolio-images"
                    alt="Job Portal website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Job Portal</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a href="https://quran-house-front-2.vercel.app/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\quran-house-portfolio.png"
                    className="img-fluid portfolio-images"
                    alt="Quran House website by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >Quran House</h2>
                </div>
              </div>
              <div className="col-md-3 mb-3 ">
                <a
                  href="https://top-real-estate-l-lc.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\real-estate-llc.png"
                    className="img-fluid portfolio-images"
                    alt=""
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >TOP REAL ESTATE LLC</h2>
                </div>
              </div>
            
              
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
